import { z } from "zod";

export const EventTeamAssignmentWarningsCountSchema = z.object({
  count: z.number().int(),
});
export type EventTeamAssignmentWarningsCountDTO = z.infer<
  typeof EventTeamAssignmentWarningsCountSchema
>;
